module.exports = __webpack_public_path__ + "img/icon_vip_youku1@2x.494d6dfe.png";